angular.module('aq.ui.intervalSelector', []);